import { useShowContext } from 'framework/show';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { PinTimelineButton } from 'domain/shared/timeline';
import { useOpportunityId } from 'domain/shared/opportunity';
import { UPDATE_CONTRACT_REQUEST } from 'domain/sales/opportunity/opportunityService';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { Collapsible } from 'framework/ui/field';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import RedmineIssueField from 'infrastructure/integrations/redmine/RedmineIssueField';
import ContractRequestFields from 'domain/sales/opportunity/presale/contract/ContractOutputTimelineRecordLayout/ContractRequestFields';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { Box, Typography } from '@mui/material';
import { timelineAdditionalSx } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

const ContractOutputTimelineRecordLayout = ({ onEdit, isPinned, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { data } = useShowContext();
  const timelineId = data.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  const buttons = [<EditTimelineRecordButton onEdit={onEdit} permissionToCheck={UPDATE_CONTRACT_REQUEST} />];

  /* eslint-disable react/no-unstable-nested-components */
  return (
    <BaseTimelineRecordLayout
      fields={
        <Collapsible>
          <ContractRequestFields />
        </Collapsible>
      }
      entity={data}
      timelineType={TimelineType.RESUME}
      buttons={buttons}
      actions={[
        <PinTimelineButton
          pinStatus={isPinned}
          pinMethod={async () => {
            const response = await pinTimelineAction!(opportunityId, timelineId, !isPinned);
            updateInList!(response?.id, response);
          }}
        />,
      ]}
      timelineFooter={() => (
        <Box display="flex" sx={timelineAdditionalSx}>
          <Typography component="span" variant="inherit">
            Redmine ticket:&nbsp;
          </Typography>
          <RedmineIssueField source="redmineTicketId" />
        </Box>
      )}
      {...props}
    />
  );
};

export default ContractOutputTimelineRecordLayout;
